import React, { useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import Confirmation from '../general/Confirmation';
import { resetState, setItemToConstruction, setCartModalVisibility } from '../../actions';

const OrderPrompt = ({ excludePaths }) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const itemInConstruction = useSelector(state => state.order.itemInConstruction);
    const showCartModal = useSelector(state => state.ui.showCartModal);

    const setPromptModal = (location) => {
        if (excludePaths.includes(location.pathname)) {
            return true;
        }

        if (itemInConstruction) {
            dispatch(setItemToConstruction(null));
        } else if (showCartModal) {
            dispatch(setCartModalVisibility(false));
        } else {
            setShow(true);
        }

        return false;
    };

    const confirmNavigation = () => {
        setShow(false);

        dispatch(resetState());
    };

    return (
        <Fragment>
            <Prompt when={true} message={setPromptModal} />
            <Confirmation open={show} onConfirm={confirmNavigation} onCancel={() => setShow(false)} />
        </Fragment>
    );
};

OrderPrompt.propTypes = {
    excludePaths: PropTypes.array
};

export default OrderPrompt;
